import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'spa-apps-software-deployments.title',
		defaultMessage: 'Deployments',
		description: 'Browser title of the page',
	},
});
